
import { ACTIONS } from '_redux/actions';
import { get } from './api';

export function fetchPageContent(params) {
  return get('page-content',
    params,
    ACTIONS.PAGE.FETCH_CONTENT,
    ACTIONS.PAGE.FETCH_CONTENT_SUCCESS,
    ACTIONS.PAGE.FETCH_CONTENT_ERROR);
}

export function prefetchPageContent(params) {
  return get('page-content',
    params,
    ACTIONS.PAGE.PRE_FETCH_CONTENT,
    ACTIONS.PAGE.PRE_FETCH_CONTENT_SUCCESS,
    ACTIONS.PAGE.PRE_FETCH_CONTENT_ERROR);
}
